(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coleccion-gabriel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var collectionItems = document.querySelectorAll('.collection-item');
  collectionItems.forEach(function(item) {
    item.addEventListener('click', function() {
      var url = this.getAttribute('data-url');
      if (url) {
        window.location.href = url;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equipo-sg"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = Array.from(entry.target.parentNode.children).indexOf(entry.target) * 100;
        entry.target.style.animation = `fadeInUp 0.8s ease ${delay}ms forwards`;
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.galeria-item').forEach(item => {
    observer.observe(item);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["historia"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', (event) => {
  const eventos = document.querySelectorAll('.evento');
  
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };
  
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = 1;
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  eventos.forEach(evento => {
    observer.observe(evento);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = Array.from(entry.target.parentNode.children).indexOf(entry.target) * 100;
        entry.target.style.animation = `fadeInUp 0.8s ease ${delay}ms forwards`;
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.video-item').forEach(item => {
    observer.observe(item);
  });
});

  } catch(e) { console.error(e); }
})();
})();
